import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(updateLocale);
var locale = {
  name: 'wm',
  // name String
  weekStart: 6,
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  formats: {},
  relativeTime: {}
};

export { locale as default };
